export default "__VITE_ASSET__e822a1e2__"